import React, { useState } from 'react'
import { Modal, Select, Button, message, Typography } from 'antd'
import { Store } from '@a4b/api/src/modules/Monetisation/Offerings/types'

const { Option } = Select;

interface Props {
    visible: boolean
    onClose: () => void
    onGenerate: (storeId: string) => void
    stores: Store[] | undefined
    isTempleListingEnabled: boolean
    storeDetails: any
}

const GenerateBatchesModal: React.FC<Props> = ({
    visible,
    onClose,
    onGenerate,
    stores,
    isTempleListingEnabled,
    storeDetails
}) => {
    const [selectedStoreId, setSelectedStoreId] = useState<string>('')

    const handleGenerate = () => {
        let storeIdToUse = selectedStoreId

        if (!isTempleListingEnabled) {
            storeIdToUse = storeDetails?.id
        }

        if (!storeIdToUse) {
            message.warning('Store ID is missing.')
            return
        }

        const selectedStore = isTempleListingEnabled
            ? stores?.find(store => store.id === selectedStoreId)
            : storeDetails

        if (isTempleListingEnabled && !selectedStore) {
            message.warning('Please select a store before generating batches')
            return
        }

        Modal.confirm({
            title: 'Confirm Batch Generation',
            content: (
                <>
                    <p>You are about to generate batches for:</p>
                    <p><strong>Store:</strong> {selectedStore?.name}</p>
                    <p><strong>Store ID:</strong> {selectedStore?.id}</p>
                    <p>Are you sure you want to proceed?</p>
                </>
            ),
            onOk: () => {
                onGenerate(storeIdToUse)
                onClose()
                setSelectedStoreId('')
            },
            okText: 'Yes',
            cancelText: 'No',
        })
    }

    return (
        <Modal
            title="Generate Batches"
            visible={visible}
            onCancel={() => {
                onClose()
                setSelectedStoreId('')
            }}
            footer={null}
            destroyOnClose
        >
            {isTempleListingEnabled ? (
                <>
                    <Typography.Text strong style={{ display: 'block', marginBottom: 8 }}>
                        Select a Store to Generate Batches
                    </Typography.Text>
                    <Select
                        placeholder="Search and select a store"
                        value={selectedStoreId || undefined}
                        onChange={setSelectedStoreId}
                        style={{ width: '100%', marginBottom: 16 }}
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                            (option?.label as string)?.toLowerCase().includes(input.toLowerCase())
                        }
                    >
                        {stores?.map((store) => (
                            <Option key={store.id} value={store.id} label={`${store.name} (${store.id})`}>
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <span style={{ fontWeight: 500 }}>{store.name}</span>
                                    <span style={{ fontSize: 12, color: '#888' }}>ID: {store.id}</span>
                                </div>
                            </Option>
                        ))}
                    </Select>
                </>
            ) : (
                <Typography.Paragraph>
                    You are about to generate batches in <strong>{storeDetails?.name}</strong>.
                </Typography.Paragraph>
            )}
            <Button type="primary" block onClick={handleGenerate}>
                Generate Batches
            </Button>
        </Modal>
    )
}

export default GenerateBatchesModal
